/**
* Modular Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Modular Grid component.
*/

const {create} = require( '@splidejs/splide/src/js/utils' );

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'modular-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      mapboxgl.accessToken = llMapbox.token;

      $( '.location-map' ).each( function() {
        const mapLocations = $( this ).data( 'locations' );
        // unique id to render map in
        const mapId = $( this ).attr( 'id' );

        const map = new mapboxgl.Map( {
          container: mapId,
          center: [mapLocations.long, mapLocations.lat],
          style: llMapbox.style,
          zoom: 13,
        } );

        const html = document.querySelector( '#location-popup' ).innerHTML;

        const popup = new mapboxgl.Popup( {offset: 25} ).setHTML(
            html,
        );

        const el = document.createElement( 'div' );
        el.className = 'marker';

        new mapboxgl.Marker( el ).setLngLat( [mapLocations.long, mapLocations.lat] ).setPopup( popup ).addTo( map );


        // function createPopUp( currentLocation, map ) {
        //   const popUps = document.getElementsByClassName( 'mapboxgl-popup' );
        //   // remove popups if any are open
        //   if ( popUps[0] ) popUps[0].remove();

        //   new mapboxgl.Popup( {offset: {'bottom': [0, -49]}} )
        //       .setLngLat( currentLocation.geometry.coordinates )
        //       .setHTML( currentLocation.properties.description )
        //       .addTo( map );
        // }

        // createPopUp( mapId, map );

        map.scrollZoom.disable();

        map.addControl( new mapboxgl.NavigationControl() );
      } );

      // function loadMap( mapLocations, mapId ) {
      //   const places = [];
      //   let bounds;

      //   if ( mapLocations.length > 1 ) {
      //     bounds = new mapboxgl.LngLatBounds();
      //   }

      //   mapLocations.forEach( ( loc, index ) => {
      //     const place = {
      //       type: 'Feature',
      //       properties: {
      //         id: index,
      //       },
      //       geometry: {
      //         type: 'Point',
      //         coordinates: [parseFloat( loc.long ), parseFloat( loc.lat )],
      //       },
      //     };

      //     places.push( place );

      //     if ( mapLocations.length > 1 ) {
      //       bounds.extend( place.geometry.coordinates );
      //     }
      //   } );

      //   let center;
      //   if ( mapLocations.length === 1 ) {
      //     center = places[0].geometry.coordinates;
      //   } else {
      //     center = bounds.getCenter();
      //   }

      //   const map = new mapboxgl.Map( {
      //     container: mapId, // mounts on the elements current id
      //     style: llMapbox.style, // stylesheet URL set in PHP file
      //     center: center,
      //     zoom: 10,
      //   } );

      //   // if there are multiple locations will make sure
      //   // all locations are visible on load
      //   // padding can be increased or decreased to make sure
      //   // there is more space between the furthest markers and the edge of the map
      //   if ( mapLocations.length > 1 ) {
      //     map.fitBounds( bounds, {padding: 80} );
      //   }

      //   // add locations from the places array to the map
      //   // and create the markers
      //   // and add the map navigations controls
      //   map.on( 'load', () => {
      //     // add this "geojson" object to the map, passing in the places array
      //     map.addSource( 'points', {
      //       type: 'geojson',
      //       data: {
      //         type: 'FeatureCollection',
      //         features: places,
      //       },
      //     } );

      //     addMarkers( places, map );

      //     map.addControl( new mapboxgl.NavigationControl() );
      //   } );
      // }

      // function addMarkers( locations, map ) {
      //   locations.forEach( function( marker, i ) {
      //     const el = document.createElement( 'div' );
      //     /* Assign a unique `id` to the marker. */
      //     el.id = 'marker-' + marker.properties.id;
      //     /* Assign the `marker` class to each marker for styling. */
      //     el.className = 'marker';
      //     // you can add you svg here through js or set is as background image or whichever you prefer. Anything can be used as a marker in this situation.

      //     /**
      //      * Create a marker using the div element
      //      * defined above and add it to the map.
      //      **/
      //     new mapboxgl.Marker( el, {offset: [0, -23]} )
      //         .setLngLat( marker.geometry.coordinates )
      //         .addTo( map );

      //     /* Add a click event to marker to open the location popup */
      //     el.addEventListener( 'click', function( e ) {
      //       createPopUp( marker, map );
      //       e.stopPropagation();
      //     } );
      //   } );
      // }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'modular-grid', COMPONENT );
} )( app );
